export default {
	cinema: {
		address: 'ул. Пражская, д. 48/50',
		place: 'м. Международная',
		phoneNumbers: ['8 (812) 207-12-97'],
		facebook: null,
		instagram: null,
		vk: 'https://vk.com/kinogradspb',
		twitter: null,
		odnoklassniki: null,
		youtube: null,
		app: {
			appstore: null,
			googleplay: null,
		},
		payment: {
			active: true,
			card: ['mir', 'visa', 'mastercard', 'maestro', 'sbp', 'sberpay'],
		},
		maps: 'https://yandex.ru/maps/-/CBuXnSTZCD',
		selectButton: {
			options: [{
				value: 'https://polyus.cinema-grad.com',
				title: 'ТРК «Южный Полюс»',
			},
			{
				value: 'https://nahodka.cinema-grad.com',
				title: 'ТРК «Порт Находка»',
			},
			{
				value: 'https://vidnoe.cinema-grad.com',
				title: 'Видное',
			}],
			selectedOptionValue: 'https://polyus.cinema-grad.com',
		},
		soonPageIsEnabled: false,
		saleRules: false,
		details: false,
	},
	feedback: true,
};
